import IconHelpButtonClose from '../../src/legacy/IconHelpButtonClose';
export default IconHelpButtonClose;
